<script setup lang="ts">
import { useTeamStore } from '@/store/teamStore'
import {
  ComparePlanModal,
  ProPlanUpgradeModal,
  TeamPlanUpgradeModal
} from './parts'

interface Props {
  plan: 'pro' | 'team' | 'auto' // どのプランのモーダルを出すか
  description?: string // slotでも指定できる
  defaultShown?: boolean
}
const props = withDefaults(defineProps<Props>(), { defaultShown: false })
const { plan, defaultShown } = toRefs(props)

const show = ref(defaultShown.value)

const page = ref<'upgrade' | 'compare'>('upgrade')

const teamStore = useTeamStore()
const { belongsToTeam } = storeToRefs(teamStore)
const modalPlan = computed<'pro' | 'team'>(() => {
  // 指定されている場合は、その値を使う
  if (plan.value === 'pro' || plan.value === 'team') return plan.value
  // 指定されていない場合はチームに所属していれば、チームしていなければプロ
  return belongsToTeam.value ? 'team' : 'pro'
})
</script>

<template>
  <div class="inline-block" @click.capture="show = true">
    <slot />
  </div>
  <div v-show="show" class="or-ft-black">
    <div v-if="show">
      <ProPlanUpgradeModal
        v-if="modalPlan === 'pro'"
        @compare="page = 'compare'"
        @close="show = false"
      >
        <template #description>
          <Description v-if="description">
            {{ description }}
          </Description>
          <slot name="description" />
        </template>
      </ProPlanUpgradeModal>
      <TeamPlanUpgradeModal
        v-if="modalPlan === 'team'"
        @compare="page = 'compare'"
        @close="show = false"
      >
        <template #description>
          <Description v-if="description">
            {{ description }}
          </Description>
          <slot name="description" />
        </template>
      </TeamPlanUpgradeModal>
    </div>
    <ComparePlanModal v-if="page === 'compare'" @close="page = 'upgrade'" />
  </div>
</template>
